import React from 'react';

import styles from './Proto.module.scss';

const Proto = () => (
  <div className={styles.protoWrapper}>
    <a href="/">&lt; Back</a>
    <div className={styles.protoContainer}>
      <div>
        <h2>Prototype</h2>
        <p>Feature coming soon!</p>
      </div>
    </div>
  </div>
)

export default Proto;
